/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.29",
    versionName: "0.2.0-nightly.2026.1.29",
    versionChannel: "nightly",
    buildDate: "2026-01-29T00:09:10.836Z",
    commitHash: "186b7bd8c8b5d465dddb6eaca404b2cc94ebdb4a",
};
